import ThemeAsset from "@common-components/theme/theme-asset";
import { appConfig } from "@common-config/app.config";
import { useRouter } from "@common-reducers/hooks/use-router";

export const SidebarLogo = () => {
    const router = useRouter();
    
    return (
        <ThemeAsset
            assetName='logo.svg'
            style={{ 
                height: '32px', 
                width: 'auto',
                cursor: 'pointer',
                objectFit: 'cover',
                objectPosition: 'left'
            }}
            alt={`${appConfig.DEFAULT_TITLE}-logo`}
            onClick={() => router.navigate('/calendar')}
        />
    );
};

// Exporting component
